// Mesmo fundo e contorno usados no destaque de documentos devolvidos.
export const destaqueAcaoNovidades = {
  "@keyframes piscarNovidade": {
    "0%, 100%": {
      backgroundColor: "var(--sear-superficie-azul, #eef7ff)",
      boxShadow: "0 0 0 0 rgba(23, 111, 178, 0.15)",
    },
    "50%": {
      backgroundColor: "var(--sear-superficie-azul, #d2e9fc)",
      boxShadow: "0 0 0 5px rgba(23, 111, 178, 0.3)",
    },
  },
  color: "var(--sear-azul, #075bb7)",
  bgcolor: "var(--sear-superficie-azul, #eef7ff)",
  outline: "2px solid var(--sear-borda-forte, #176fb2)",
  outlineOffset: "-2px",
  animation: "piscarNovidade 1.4s ease-in-out infinite",
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};
